import styles from './AboutMe.module.scss';

export const AboutMeContainer = () => {
    return (
        <div className={styles['about-me-container']}>
            <div className={styles['black-bg']}>
                <div className={styles['about-me-wrapper']} id="about-me">
                    <div className={styles['title']}>
                        <p>Rebecca Stamey-White</p>
                        <p>About Me</p>
                    </div>
                    <div className={styles['copy-wrapper']}>
                        <p>Rebecca Stamey-White brings over 15 years of legal experience to the alcohol and cannabis
                            industries, representing clients across all levels of the supply chain—producers,
                            distributors, and retailers—as well as tech companies, e-commerce platforms, and brands. Her
                            extensive background provides a nuanced understanding of the challenges and opportunities
                            facing businesses in these highly regulated sectors.

                            With a strategic and proactive approach, Rebecca leverages her knowledge of the national
                            regulatory landscape, helping clients navigate the complexities of licensing, compliance,
                            and operational requirements across multiple jurisdictions. Her tech-enabled legal solutions
                            streamline the compliance process, empowering clients to focus on growth while staying ahead
                            of regulatory shifts. Rebecca is committed to providing guidance that not only safeguards
                            her clients’ businesses but also supports their long-term success in this rapidly evolving
                            market.</p>
                    </div>
                    <div className={styles['button-wrapper']}>
                        <a href="https://www.linkedin.com/in/rebeccastameywhite/" target="_blank">

                            <div className={styles['button']}>
                                <img src="./connectwithmelinkedinin.svg"
                                     alt="linkedin-icon"/>
                            </div>
                        </a>
                    </div>
                    <div className={styles['headshot-wrapper']}>
                        <img src="./Headshot.png" alt="headshot"/>
                    </div>
                </div>
            </div>
        </div>
    )
};